module.exports = __webpack_public_path__ + "img/object-feature-person-before.7bde6f20.webp";